const teamsConstants = {
	ACCEPT_REQUEST_TO_JOIN_PENDING: 'ACCEPT_REQUEST_TO_JOIN_PENDING',
	ACCEPT_REQUEST_TO_JOIN_FULFILLED: 'ACCEPT_REQUEST_TO_JOIN_FULFILLED',
	ACCEPT_REQUEST_TO_JOIN_REJECTED: 'ACCEPT_REQUEST_TO_JOIN_REJECTED',

	ADD_TEAM_IMAGE_REJECTED: 'ADD_TEAM_IMAGE_REJECTED',
	ADD_TEAM_IMAGE_SUCCESS: 'ADD_TEAM_IMAGE_SUCCESS',

	DECLINE_REQUEST_TO_JOIN_PENDING: 'DECLINE_REQUEST_TO_JOIN_PENDING',
	DECLINE_REQUEST_TO_JOIN_FULFILLED: 'DECLINE_REQUEST_TO_JOIN_FULFILLED',
	DECLINE_REQUEST_TO_JOIN_REJECTED: 'DECLINE_REQUEST_TO_JOIN_REJECTED',

	FETCH_TEAMS: 'FETCH_TEAMS',
	FETCH_TEAMS_PENDING: 'FETCH_TEAMS_PENDING',
	FETCH_TEAMS_FULFILLED: 'FETCH_TEAMS_FULFILLED',
	FETCH_TEAMS_REJECTED: 'FETCH_TEAMS_REJECTED',

	FETCH_MY_TEAMS_PENDING: 'FETCH_MY_TEAMS_PENDING',
	FETCH_MY_TEAMS_FULFILLED: 'FETCH_MY_TEAMS_FULFILLED',
	FETCH_MY_TEAMS_REJECTED: 'FETCH_MY_TEAMS_REJECTED',

	FETCH_SELECTED_TEAM: 'FETCH_SELECTED_TEAM',
	FETCH_SELECTED_TEAM_PENDING: 'FETCH_SELECTED_TEAM_PENDING',
	FETCH_SELECTED_TEAM_FULFILLED: 'FETCH_SELECTED_TEAM_FULFILLED',
	FETCH_SELECTED_TEAM_REJECTED: 'FETCH_SELECTED_TEAM_REJECTED',

	GET_LIST_REQUESTS_JOINING_PENDING: 'GET_LIST_REQUESTS_JOINING_PENDING',
	GET_LIST_REQUESTS_JOINING_FULFILLED: 'GET_LIST_REQUESTS_JOINING_FULFILLED',
	GET_LIST_REQUESTS_JOINING_REJECTED: 'GET_LIST_REQUESTS_JOINING_REJECTED',

	JOIN_TO_TEAM_PENDING: 'JOIN_TO_TEAM_PENDING',
	JOIN_TO_TEAM_FULFILLED: 'JOIN_TO_TEAM_FULFILLED',
	JOIN_TO_TEAM_REJECTED: 'JOIN_TO_TEAM_REJECTED',

	SEARCH_TEAMS: 'SEARCH_TEAMS',
	SEARCH_TEAMS_PENDING: 'SEARCH_TEAMS_PENDING',
	SEARCH_TEAMS_FULFILLED: 'SEARCH_TEAMS_FULFILLED',
	SEARCH_TEAMS_REJECTED: 'SEARCH_TEAMS_REJECTED',

	CREATE_PENDING: 'CREATE_TEAM_PENDING',
	CREATE_SUCCESS: 'CREATE_TEAM_FULFILLED',
	CREATE_ERROR: 'CREATE_TEAM_ERROR',

	UPDATE_PENDING: 'UPDATE_TEAM_PENDING',
	UPDATE_SUCCESS: 'UPDATE_TEAM_FULFILLED',
	UPDATE_ERROR: 'UPDATE_TEAM_ERROR',

	UPDATE_SELECTED_TEAM_PENDING: 'UPDATE_SELECTED_TEAM_PENDING',
	UPDATE_SELECTED_TEAM_SUCCESS: 'UPDATE_SELECTED_TEAM_FULFILLED',
	UPDATE_SELECTED_TEAM_ERROR: 'UPDATE_SELECTED_TEAM_ERROR',

	INVITE_TEAM_MEMBERS_PENDING: 'INVITE_TEAM_MEMBERS_PENDING',
	INVITE_TEAM_MEMBERS_FULFILLED: 'INVITE_TEAM_MEMBERS_FULFILLED',
	INVITE_TEAM_MEMBERS_REJECTED: 'INVITE_TEAM_MEMBERS_REJECTED',

	SB_MY_TEAMS: 'SB_MY_TEAMS',

	CLEAR_SELECTED_TEAM: 'CLEAR_SELECTED_TEAM',
};

export default teamsConstants;
